<template>
  <div class="min-h-screen w-screen overflow-hidden flex flex-col">
    <div>
      <step-progress step="1" class="py-4 mx-auto bg-dark-blue px-4"></step-progress>
    </div>
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-4xl lg:mt-20 flex flex-1 lg:flex-grow-0 flex-wrap justify-center">

      <div class="hidden lg:block w-2/5 transform -translate-x-32">
        <img src="/images/business-woman@2x.jpg" alt="Start test" class="object-cover shadow-lg">
      </div>

      <div
          class="lg:w-3/5 lg:-ml-12 flex flex-col justify-between lg:flex-row lg:flex-wrap items-center lg:items-start text-center">
        <p class="hidden lg:block uppercase text-sm font-bold text-medium-blue w-full text-center">Test :
          {{ $page.props.survey.title[$locale()] }}</p>

        <div>
          <survey-question v-for="(question, key) in $page.props.survey.questions" :key="key" :question="question"
                           v-model="form.responses[key]" :id="'question-'+(key+1)"
                           v-show="currentQuestion === key"></survey-question>

          <div class="py-1 px-3 mt-4 rounded-lg bg-red-100 text-red-600" v-if="error">{{ error }}</div>
        </div>

        <div :class="{ 'justify-end' : isFirst, 'justify-between' : !isFirst }" class="flex items-center w-full mt-6">
          <bubble-button @click="prevQuestion" v-if="!isFirst" type="disabled" arrow="reverse">{{
              $trans('app.prev')
            }}
          </bubble-button>
          <bubble-button @click="nextQuestion" @keyup.right="nextQuestion" v-if="!isLast" :disabled="!answerIsValid">
            {{ $trans('app.next') }}
          </bubble-button>
          <bubble-button @click="submitForm" v-if="isLast">{{ $trans('app.validate') }}</bubble-button>
        </div>
      </div>

      <button @click="fillForm" class="z-50 absolute top-0 right-0 m-2 bg-white p-2 rounded-lg"
              v-if="$page.props.env === 'local'">Remplir
      </button>

    </div>
  </div>
</template>

<script>
import SurveyQuestion from "@/Components/SurveyQuestion";
import AppLayout from '@/Layouts/AppLayout.vue';
import StepProgress from '@/Components/StepProgress.vue';
import BubbleButton from '@/Components/BubbleButton.vue';

export default {
  name: "Questions",
  components: {
    SurveyQuestion,
    AppLayout,
    StepProgress,
    BubbleButton
  },
  props: {
    submission: {
      default: null,
    }
  },
  data() {
    return {
      form: {
        survey: this.$page.props.survey.id,
        submission: this.$page.props.submission,
        lang: this.$locale(),
        responses: []
      },
      currentQuestion: 0,
      error: ''
    }
  },
  mounted() {
    this.error = ''
  },
  computed: {
    isFirst() {
      return this.currentQuestion === 0;
    },
    isLast() {
      return this.currentQuestion === this.$page.props.survey.questions.length - 1;
    },
    answerIsValid() {
      return !!this.form.responses[this.currentQuestion];
    }
  },
  methods: {
    submitForm() {
      this.$inertia.post(route('submission.store', {
        survey: this.$page.props.survey.slug,
        token: this.route().params.token
      }),
          this.form
      )
      .catch((e) => console.log(e));
    },

    nextQuestion() {
      if (this.answerIsValid) {
        this.currentQuestion = this.currentQuestion + 1
        this.error = '';
      } else {
        this.error = 'Veuillez répondre à la question.';
      }
    },

    prevQuestion() {
      this.currentQuestion = this.currentQuestion - 1
    },

    isLastQuestion() {
      console.log(this.$page.props.survey.questions.length)
    },

    fillForm() {
      for (let i = 1; i < 36; i++) {
        this.form.responses.push({
          'question_id': i,
          'response_id': _.random(1, 6)
        })
        this.currentQuestion = 34;
      }
    }
  },
}
</script>

<style scoped>

</style>
